import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.css'],
    
})
export class SliderComponent implements OnInit {
  @Input() slider_imgs;
  @Input() url;
  @Input() type ;
  constructor(private router:Router) { }

  goToPage(detail)
  {
    if(this.type && this.type == 'category')
    {
      this.router.navigate(['subcategory',detail.category_id]);
    }
    else if(this.type && this.type == 'subcategory')
    {
      this.router.navigate(['subsub',detail.subcategory_id]);
    }
  }

  ngOnInit() {
  }

}
